import { BrowserHelper } from '@helpers/browser';
import { SessionStorageHandler } from '@helpers/session-storage';

export function useBrowser() {
  return {
    browserHelper: new BrowserHelper(),
    sessionStorageHandler: new SessionStorageHandler(),
  };
}
